import DialogUpload from '@/components/DialogUpload'
import { useAuth } from '@/hooks/use-auth'
import { useFetchCurrentUserGroups } from '@/hooks/use-fetch-current-user-groups'
import { CreateCustomerModal } from '@/sections/customerFlow/customer/CreateCustomerModal'
import { ReferentialCreateModal } from '@/sections/referentials/components/ReferentialCreateModal'
import type { CommandBarModalId } from '../types'

type CommandBarModalsHostProps = {
  activeModal: CommandBarModalId | null
  onCloseModal: () => void
}

export const CommandBarModalsHost = ({
  activeModal,
  onCloseModal,
}: CommandBarModalsHostProps) => {
  const { user } = useAuth()
  const { data: groups = [] } = useFetchCurrentUserGroups()

  return (
    <>
      <DialogUpload open={activeModal === 'create-folder'} onClose={onCloseModal} />
      <CreateCustomerModal
        open={activeModal === 'add-client'}
        onClose={onCloseModal}
        onCreated={onCloseModal}
        groups={groups}
        organizationId={user?.organization}
      />
      <ReferentialCreateModal
        open={activeModal === 'add-referential'}
        onClose={onCloseModal}
        onCreated={onCloseModal}
        groups={groups}
        userId={user?.uid}
      />
    </>
  )
}
